import { ComponentType } from 'react';
import GuidanceContent from './Guidance';
import FearMovesContent from './FearMoves';
import GmMechanics from './GmMechanics';
import AdversaryGuideContent from './AdversaryGuide';
import AdditionalGuidance from './AdditionalGuidance';
import VillainBuilder from './VillainBuilder';
import DoomTrack from './DoomTrack';

export { GuidanceContent, FearMovesContent, AdversaryGuideContent };

export const gmContent: Record<string, ComponentType> = {
  'PRINCIPLES':   GuidanceContent,
  'FEAR MOVES':   FearMovesContent,
  'GM MECHANICS': GmMechanics,
  'ADVERSARIES':  AdversaryGuideContent,
  'ADDITIONAL':   AdditionalGuidance,
  'VILLAIN BUILDER': VillainBuilder,
  'DOOM TRACK':   DoomTrack,
};
